import angular from 'angular';

(function () {
    'use strict';

    angular.module('app.kissuser').config(routesConfig);

    routesConfig.$inject = ['$stateProvider'];

    /* @ngInject */
    function routesConfig($stateProvider) {
        $stateProvider
            .state('app.kissuser', {
                abstract: true,
                component: 'contentLayout',
            })
            .state('app.kissuser.list', {
                url: '/kiss-user/list',
                resolve: {
                    keepSearchData: keepSearchData,
                },
                views: {
                    content: {
                        component: 'listKissUsers',
                    },
                },
            })
            .state('app.kissuser.new', {
                url: '/kiss-user/:principalId/:legalEntityId/new',
                resolve: {
                    principal: getPrincipal,
                    groups: getPrincipalGroups,
                    userBoData: getUserCreationData,
                    legalEntity: getNullableLegalEntity,
                },
                views: {
                    content: {
                        component: 'userDetail',
                    },
                },
                data: {
                    authorizedRole: 'SUPPORT',
                },
            })
            .state('app.kissuser.edit', {
                url: '/kiss-user/:principalId/:legalEntityId/:id/edit',
                resolve: {
                    userBoData: getUser,
                    groups: getNullablePrincipalGroups,
                    principal: getNullablePrincipal,
                    legalEntity: getNullableLegalEntity,
                },
                views: {
                    content: {
                        component: 'userDetail',
                    },
                },
                data: {
                    authorizedRole: 'SUPPORT',
                },
                params: { sellerId: null },
            });

        getUser.$inject = ['$transition$', 'KissUserSvc'];
        function getUser($transition$, KissUserSvc) {
            return KissUserSvc.getUser($transition$.params().id, $transition$.params().sellerId);
        }

        keepSearchData.$inject = ['$transition$'];
        function keepSearchData($transition$) {
            return $transition$.from().name === 'app.kissuser.edit';
        }

        getUserCreationData.$inject = ['KissUserSvc'];
        function getUserCreationData(KissUserSvc) {
            return KissUserSvc.getUserCreationData();
        }

        getPrincipalGroups.$inject = ['$transition$', 'PrincipalSvc', 'TYPEGROUPE'];
        function getPrincipalGroups($transition$, PrincipalSvc, TYPEGROUPE) {
            /** Type du groupe : (ALL, STANDARD,INVITED_SELLER). */
            let criteria = {};
            criteria.types = [TYPEGROUPE.invitedSeller, TYPEGROUPE.standard];
            criteria.companyId = $transition$.params().legalEntityId;
            return PrincipalSvc.searchGroups($transition$.params().principalId, criteria);
        }

        getPrincipal.$inject = ['$transition$', 'PrincipalSvc'];
        function getPrincipal($transition$, PrincipalSvc) {
            return PrincipalSvc.getPrincipalById($transition$.params().principalId);
        }

        getNullableLegalEntity.$inject = ['$transition$', 'PrincipalSvc'];
        function getNullableLegalEntity($transition$, PrincipalSvc) {
            const legalEntityId = $transition$.params().legalEntityId;
            if (!legalEntityId) {
                return null;
            }
            return PrincipalSvc.getLegalEntity($transition$.params().principalId, legalEntityId);
        }

        /** Lorsque l'utilisateur n'est rattaché à aucune entité juridique, Le DO auquel il est rattaché est null, dans cas on fournit un groupe vide lors de l'affichage du detail de l'utilisateur. */
        getNullablePrincipalGroups.$inject = ['$transition$', 'PrincipalSvc', 'TYPEGROUPE'];
        function getNullablePrincipalGroups($transition$, PrincipalSvc, TYPEGROUPE) {
            if (!$transition$.params().principalId) {
                return [];
            }
            let criteria = {};
            criteria.companyId = $transition$.params().legalEntityId;
            criteria.types = [TYPEGROUPE.invitedSeller, TYPEGROUPE.standard];
            return PrincipalSvc.searchGroups($transition$.params().principalId, criteria);
        }

        /** Lorsque l'utilisateur n'est rattaché à aucune entité juridique, Le DO auquel il est rattaché est null, dans cas on ne fournit pas de DO lors de l'affichage du detail de l'utilisateur. */
        getNullablePrincipal.$inject = ['$transition$', 'PrincipalSvc'];
        function getNullablePrincipal($transition$, PrincipalSvc) {
            if (!$transition$.params().principalId) {
                return null;
            }
            return PrincipalSvc.getPrincipalById($transition$.params().principalId);
        }
    }
})();
